<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div v-html="html"></div>
</template>

<script setup lang="tsx">
import { useTable } from '../../../hooks/use-table';

const props = defineProps<{
  tableHeaderList: any;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();

const className = 'normal-table-5';
const attrs = `border='0' bordercolor='#C0BEC7'`;
const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);
</script>
<style lang="scss">
@import '../../../styles/custom-table.scss';
.normal-table-5 {
  thead {
    th {
      color: #fff;
      & > div {
        background-color: var(--theme-color-1);
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
      }
      & + th {
        & > div {
          margin-left: 6px;
        }
      }
    }
  }
  tbody {
    tr {
      position: relative;
      height: 60px;
      break-inside: avoid;
      td {
        & > div {
          border-left: 2pt solid var(--theme-color-1);
          border-right: 2pt solid var(--theme-color-1);
          position: relative;
          background: var(--theme-color-1-10);
        }
        & + td {
          & > div {
            margin-left: 6px;
          }
        }
      }
      &:last-child {
        & > td > div {
          border-bottom: 2pt solid var(--theme-color-1);
        }
      }
    }
  }
}
</style>
